import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cadastrar-plano-cargo-salario',
  templateUrl: './cadastrar-plano-cargo-salario.component.html',
  styleUrls: ['./cadastrar-plano-cargo-salario.component.css']
})
export class CadastrarPlanoCargoSalarioComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
